import SEOHead, {
  siteSchema,
  organizationSchema,
  webPageSchema,
  faqSchema,
} from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import CategoryPreview from './components/CategoryPreview';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import RankingSection from './components/RankingSection';

const PAGE_TITLE = '韩国漫画大全_最新热门韩国漫画推荐_最火韩国漫画排行榜';
const PAGE_DESC = '韩漫网汇集最新热门韩漫推荐和最火排行榜，大全作品免费阅读，在线观看无限制，下拉式设计让您轻松探索多样内容。';
const PAGE_KEYWORDS = '韩漫网,最新热门推荐,最火排行榜,漫画大全,免费阅读,在线观看';

export default function Home() {
  const schemas = {
    ...siteSchema(),
    ...organizationSchema(),
    ...webPageSchema({
      title: PAGE_TITLE,
      description: PAGE_DESC,
      url: '/',
    }),
    ...faqSchema([
      {
        question: '韩漫网是什么？',
        answer: '韩漫网是一个专业的韩国漫画在线阅读平台，汇集了最新最热的韩国漫画作品，提供免费在线阅读服务。下拉式设计让您轻松浏览多样内容，涵盖恋爱、奇幻、动作、悬疑等多种类型。',
      },
      {
        question: '韩漫网如何观看漫画？',
        answer: '只需访问韩漫网，选择您喜欢的漫画，点击即可开始阅读。平台采用创新的下拉式设计，在手机和电脑上都能获得流畅的阅读体验。所有内容均可免费观看，无需注册。',
      },
      {
        question: '韩漫网的漫画更新频率如何？',
        answer: '韩漫网与多家韩国漫画平台合作，确保热门作品能够第一时间更新。大多数连载作品保持每周更新，部分热门作品甚至可以达到每日更新，让读者不再忍受等待的煎熬。',
      },
      {
        question: '韩漫网的漫画是否需要付费？',
        answer: '韩漫网目前所有漫画内容均提供免费阅读服务，用户可以直接在线观看，无需支付任何费用。我们致力于让更多人享受到优质韩国漫画的阅读乐趣。',
      },
    ]),
  };

  return (
    <>
      <SEOHead
        title={PAGE_TITLE}
        description={PAGE_DESC}
        keywords={PAGE_KEYWORDS}
        canonicalUrl="/"
        ogImage="https://readdy.ai/api/search-image?query=Korean%20manhwa%20website%20homepage%20hero%20banner%20featuring%20popular%20Korean%20comics%20covers%20collage%20with%20warm%20vibrant%20colors%2C%20clean%20modern%20design%2C%20attractive%20layout&width=1200&height=630&seq=og-home-2026&orientation=landscape"
        schema={schemas}
      />
      <HeroSection />
      <TrendingSection />
      <CategoryPreview />
      <RankingSection />
      <TestimonialSection />
      <CTASection />
    </>
  );
}